<template>
  <router-view />
</template>
<script>
export default {
  mounted() {
    // 友盟统计添加
    const script = document.createElement("script");
    script.src =
      "https://s9.cnzz.com/z_stat.php?id=1280379441&web_id=1280379441"; //该路径为点击统计代码后，页面中第一个 文字统计 script代码
    script.language = "JavaScript";
    document.body.appendChild(script);
  },

  watch: {
    $route() {
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = "/";
        window._czc.push(["_trackPageview", contentUrl, refererUrl]);
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
